import { Injectable, inject } from '@angular/core';
import Keycloak from 'keycloak-js';
import {AllUserRoles} from "../../../models/enum/all-user-roles";

@Injectable({ providedIn: 'root' })
export class UserRolesService {
    private readonly kc = inject(Keycloak);

    // helper: controlla sia realm che client roles (del client corrente)
    private hasRole(role: string): boolean {
        return this.kc.hasRealmRole(role) || this.kc.hasResourceRole(role);
    }

    // se vuoi anche leggere tutte le stringhe ruolo presenti nel token:
    getAllRoles(): string[] {
        const realm = this.kc.realmAccess?.roles ?? [];
        const clientRoles = Object.values(this.kc.resourceAccess ?? {}).flatMap(r => r?.roles ?? []);
        return Array.from(new Set([...realm, ...clientRoles]));
    }

    isZentivaCorp(): boolean       { return this.hasRole(AllUserRoles.ZENTIVA_CORPORATE); }
    isZentivaSales(): boolean      { return this.hasRole(AllUserRoles.ZENTIVA_SALES); }
    isHvsUser(): boolean           { return this.hasRole(AllUserRoles.HVS_USER); }
    isHvsSupervisor(): boolean     { return this.hasRole(AllUserRoles.HVS_SUPERVISOR); }
}
